import { parseFromStripe } from "./parseFromStripe";

const today = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 0,
    amount_paid: 0,
    amount_remaining: 0,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1694738219,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [
        {
            id: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            object: "tax_rate",
            active: true,
            country: "MY",
            created: 1693369528,
            description: "SST",
            display_name: "Sales tax",
            effective_percentage: 6.0,
            inclusive: false,
            jurisdiction: null,
            livemode: false,
            metadata: {},
            percentage: 6.0,
            state: null,
            tax_type: null,
        },
    ],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: -2162,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_135c62GSTSE9ZxBoa9eeb4ce",
                object: "line_item",
                amount: -2728,
                amount_excluding_tax: -2728,
                currency: "myr",
                description: "Unused time on Subscription (Monthly) after 15 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1NqQ1nGSTSE9ZxBoxwjvgOD2",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1694738219,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 5900,
                    amount_decimal: "5900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBol7EKURyb",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "inclusive",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 5900,
                    unit_amount_decimal: "5900",
                },
                proration: true,
                proration_details: {
                    credited_items: {
                        invoice: "in_1NkNMiGSTSE9ZxBoFc7Ff9ld",
                        invoice_line_items: [
                            "il_1NkNMiGSTSE9ZxBoSy2zspKO",
                        ],
                    },
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OXSHx7ZMeCK8Mf",
                tax_amounts: [
                    {
                        amount: -164,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: -2728,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "-2728",
            },
            {
                id: "il_tmp_16d4aaGSTSE9ZxBo1b036cad",
                object: "line_item",
                amount: 689,
                amount_excluding_tax: 689,
                currency: "myr",
                description: "Remaining time on WhatsApp File Top Up after 15 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1NqQ1nGSTSE9ZxBoJo7ShEbK",
                livemode: false,
                metadata: {},
                period: {
                    end: 1695976416,
                    start: 1694738219,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: true,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OdhQysswy8TTfP",
                tax_amounts: [
                    {
                        amount: 41,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 689,
                    },
                ],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "689",
            },
        ],
        has_more: false,
        total_count: 2,
        url: "/v1/invoices/upcoming/lines?subscription=sub_1NkNMiGSTSE9ZxBoRpjxTwNC&subscription_proration_behavior=always_invoice&subscription_default_tax_rates%5B%5D=txr_1Nkfy8GSTSE9ZxBoFANix2G3&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OXSHx7ZMeCK8Mf&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B1%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoY5RZTJkp&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bprice%5D=price_1LmYqvGSTSE9ZxBoMrP5HRQX&subscription_items%5B2%5D%5Bquantity%5D=1&subscription_items%5B2%5D%5Bdeleted%5D=false&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1694738219,
    period_start: 1693298016,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1694738219,
    subtotal: -2039,
    subtotal_excluding_tax: -2039,
    tax: -123,
    test_clock: null,
    total: -2162,
    total_discount_amounts: [],
    total_excluding_tax: -2039,
    total_tax_amounts: [
        {
            amount: -123,
            inclusive: false,
            tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            taxability_reason: null,
            taxable_amount: -2039,
        },
    ],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const nextNoProration = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 1579,
    amount_paid: 0,
    amount_remaining: 1579,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1695976416,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [
        {
            id: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            object: "tax_rate",
            active: true,
            country: "MY",
            created: 1693369528,
            description: "SST",
            display_name: "Sales tax",
            effective_percentage: 6.0,
            inclusive: false,
            jurisdiction: null,
            livemode: false,
            metadata: {},
            percentage: 6.0,
            state: null,
            tax_type: null,
        },
    ],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_16afb4GSTSE9ZxBo4051a7b6",
                object: "line_item",
                amount: 1490,
                amount_excluding_tax: 1490,
                currency: "myr",
                description: "1 × WhatsApp File Top Up (at RM14.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698568416,
                    start: 1695976416,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OdhRjkScqDany1",
                tax_amounts: [
                    {
                        amount: 89,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 1490,
                    },
                ],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "1490",
            },
            {
                id: "il_tmp_1f96c2GSTSE9ZxBo4c26e66a",
                object: "line_item",
                amount: 0,
                amount_excluding_tax: 0,
                currency: "myr",
                description: "1 × Subscription (Monthly) (at RM0.00 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1698568416,
                    start: 1695976416,
                },
                plan: {
                    id: "price_1LmYqvGSTSE9ZxBoMrP5HRQX",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 0,
                    amount_decimal: "0",
                    billing_scheme: "per_unit",
                    created: 1664266157,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Launch",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LmYqvGSTSE9ZxBoMrP5HRQX",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1664266157,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Launch",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 0,
                    unit_amount_decimal: "0",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
                subscription_item: "si_OdhRGtOW3LxShg",
                tax_amounts: [
                    {
                        amount: 0,
                        inclusive: false,
                        tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
                        taxability_reason: null,
                        taxable_amount: 0,
                    },
                ],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "0",
            },
        ],
        has_more: false,
        total_count: 2,
        url: "/v1/invoices/upcoming/lines?subscription=sub_1NkNMiGSTSE9ZxBoRpjxTwNC&subscription_proration_behavior=none&subscription_default_tax_rates%5B%5D=txr_1Nkfy8GSTSE9ZxBoFANix2G3&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OXSHx7ZMeCK8Mf&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B1%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoY5RZTJkp&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bprice%5D=price_1LmYqvGSTSE9ZxBoMrP5HRQX&subscription_items%5B2%5D%5Bquantity%5D=1&subscription_items%5B2%5D%5Bdeleted%5D=false&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: 1695980016,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1695976416,
    period_start: 1693298016,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NkNMiGSTSE9ZxBoRpjxTwNC",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1694738274,
    subtotal: 1490,
    subtotal_excluding_tax: 1490,
    tax: 89,
    test_clock: null,
    total: 1579,
    total_discount_amounts: [],
    total_excluding_tax: 1490,
    total_tax_amounts: [
        {
            amount: 89,
            inclusive: false,
            tax_rate: "txr_1Nkfy8GSTSE9ZxBoFANix2G3",
            taxability_reason: null,
            taxable_amount: 1490,
        },
    ],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const SameCycleUpgrade = parseFromStripe(today);
const NoProration = parseFromStripe(nextNoProration);

export const SameCycleMonthToMonthDowngradeExpected = {
    today: SameCycleUpgrade,
    next: NoProration,
};
